import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useOutletContext } from 'react-router-dom';
import NoticeController, { NotificationType } from '../../controller/NoticeController';
import { CurrentStoreContext } from '../../controller/StoreController';
import moment from 'moment-timezone';

const DashboardNotification = () => {
  const { currentStore } = useOutletContext<CurrentStoreContext>();
  const [noticeList, setNoticeList] = useState<NotificationType[]>([]);

  const getlist = async (page: number) => {
    try {
      const oParams = {
        store_id: currentStore.value,
        item_count: 5,
        page,
      };
      const oRes = await NoticeController.getlist(oParams);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('getlist', oResponse.data.list);
        if (oResponse.data) {
          setNoticeList(oResponse.data.list);
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };

  useEffect(() => {
    getlist(1);
  }, [currentStore]);

  return (
    <Style>
      <div className="notificationWrap">
        <div className="title">
          <img src={`${process.env.PUBLIC_URL}/img/announcement.png`} alt="warning" width={24} />
          <h2>노크노크 공지사항</h2>
        </div>
        {noticeList.length > 0 ? (
          <Link to={'/notification/list'}>
            {noticeList.map((data, index: number) => (
              <div className="listWrap" key={index}>
                <div className="listTitle">
                  <h4>
                    {moment().diff(moment(data.created_at), 'days') < 7 && <span>NEW</span>}[공지]
                    {data.title}
                  </h4>
                  <p>{moment(data.created_at).format('YYYY-MM-DD HH:mm:ss')}</p>
                </div>
                <img
                  src={`${process.env.PUBLIC_URL}/img/rightArrow.png`}
                  alt="warning"
                  width={24}
                />
              </div>
            ))}
          </Link>
        ) : (
          <h4 className="noneList">공지사항이없습니다.</h4>
        )}
      </div>
    </Style>
  );
};

export default DashboardNotification;

const Style = styled.div`
  h2 {
    font-size: 18px;
    font-weight: 600;
    color: #333;
  }
  h4 {
    font-size: 16px;
    color: #333;
  }
  p {
    font-size: 12px;
    font-weight: 400;
    color: #999;
  }

  .notificationWrap {
    padding: 10px;
  }
  .title {
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    gap: 10px;
    border-bottom: 1px solid #333;
  }
  .listWrap {
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 12px 0;
    border-bottom: 1px solid #eee;
    gap: 30px;

    .listTitle {
      flex: 1;
      width: 200px;

      h4 {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-bottom: 2px;
      }
    }
    span {
      margin-right: 2px;
      padding: 2px 4px;
      background: #ffebeb;
      color: #ff6060;
      font-size: 10px;
      font-weight: 700;
      border-radius: 2px;
    }
  }
  .listWrap:nth-last-child(1) {
    border-bottom: none;
  }
  .listWrap:hover {
    transition: transform 0.1s ease-in-out;
    transform: scale(1.01);
  }

  .noneList {
    font-size: 16px;
    padding-top: 150px;
    text-align: center;
    color: #555;
    font-weight: 400;
  }
`;
